/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * {Document Title}
 * {Description}
 */

( function( window, $ ) {
	'use strict';
	var document = window.document;

    var readingProgress = {

        init: function() {
            $(document).on('_page_loaded load', function () {
                add_reading_progress();
            });

            function add_reading_progress(){
                var winHeight = $(window).height(), 
                    readableHeight = $('#page-content>div').height(),
                    progressBar = $('progress'),
                    max, value;

                /* Set the max scrollable area */
                max = readableHeight - winHeight;
                progressBar.attr('max', max);

                $(document).on('scroll', function(){
                   value = $(window).scrollTop();
                   progressBar.attr('value', value);
                });
            }
            
            add_reading_progress();
        }

    };

    $(document).ready(function(){
        readingProgress.init();
    });

} )(window,jQuery);
